export enum UserGroup {
  BETA = 'BETA',
  ADMIN = 'ADMIN',
  REGULAR = 'REGULAR',
}
